var staticHGKeyRE = /(.+)?\[(\d+)\]$/

module.exports = staticHGKeyRE



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticHGKeyRE.js
// module id = 5aaR
// module chunks = 137